export default __webpack_public_path__ + "static/media/python-yahtzee.1d4f2810.gif";